<!--<p-card header="Address" class="parent-p-card">-->
<!--  <div class="p-grid p-fluid">-->
<!--    <div class="col-md-12 col-sm-12 col-xs-12">-->
<form [formGroup]="addressForm">
  <div class="p-grid p-fluid parent-form">
<!--    <div class="col-md-3 col-sm-3 col-xs-0 input-container"></div>-->
    <div class="col-md-6 col-sm-6 col-xs-12 input-container">
      <label>Street Address<sup class="req">*</sup></label>
          <p-autoComplete formControlName="streetAddress" [suggestions]="autocompleteData.items" (completeMethod)="search($event)" optionLabel="street_line" (onSelect)="applySuggestion($event)" >
            <ng-template let-address pTemplate="addressDisplay">
              {{address.street_line}}  {{address.city}}, {{address.state}} {{address.zipcode}}
            </ng-template>
          </p-autoComplete>
          @if (required && (addressForm.controls.streetAddress.dirty) &&
          addressForm.controls.streetAddress.errors?.required) {
            <span class="error">'Street Address' must be provided</span>
          }
    </div>
    <div class="col-md-6 col-sm-6 col-xs-12 input-container">
      <label>Suite, Building, Floor, etc.</label>
      <input type="text" pInputText formControlName="streetAddress2" maxlength="100"  tabindex="0">
    </div>
    <div class="col-md-4 col-sm-3 col-xs-12 input-container">
      <label>City/Town<sup class="req">*</sup></label>
      <input type="text" pInputText formControlName="city" maxlength="100"  tabindex="0">
      @if (required && (addressForm.controls.city.dirty) &&
      addressForm.controls.city.errors?.required) {
        <span class="error">'City' must be provided</span>
      }
    </div>
    <div class="col-md-4 col-sm-3 col-xs-12 input-container">
      <app-select class="full-width" [inputObj]="inputObjState" (emitData)="getStateData($event)" tabindex="-1"></app-select >
    </div>
    <div class="col-md-4 col-sm-3 col-xs-12 input-container">
      <label>Postal Code<sup class="req">*</sup></label>
      <input type="text" pInputText formControlName="postalCode" maxlength="10"  tabindex="0">
      @if (required && (addressForm.controls.postalCode.dirty) &&
      addressForm.controls.postalCode.errors?.required) {
        <span class="error">'Postal Code' must be provided</span>
      }
    </div>

  </div>
</form>
<!--    </div>-->
<!--  </div>-->
<!--</p-card>-->
